import { ptsd781aNameTitle } from '../content/ptsdClassification';
import { recordsPermissionNotice } from '../content/secondaryIncidentPermissionNotice';

export const uiSchema = {
  'ui:title': ptsd781aNameTitle,
  'ui:description': recordsPermissionNotice,
};

export const schema = {
  type: 'object',
  properties: {},
};
